export default __webpack_public_path__ + "static/media/eduction.2cb8cd29.png";